const CALL = "call";
const EMAIL = "email";
const TWITTER = "twitter";

export {
    CALL,
    EMAIL,
    TWITTER
}